export const UNASSIGN_DRIVERS_REQUEST = "UNASSIGN_DRIVERS_REQUEST";
export const UNASSIGN_DRIVERS_RESULT = "UNASSIGN_DRIVERS_RESULT";
export const UNASSIGN_DRIVERS_OPEN_MODAL = "UNASSIGN_DRIVERS_OPEN_MODAL";
export const UNASSIGN_DRIVERS_CLOSE_MODAL = "UNASSIGN_DRIVERS_CLOSE_MODAL";
export const UNASSIGN_DRIVERS_GET_KEYFOB_REQUEST = "UNASSIGN_DRIVERS_GET_KEYFOB_REQUEST";
export const UNASSIGN_DRIVERS_GET_KEYFOB_RESULT = "UNASSIGN_DRIVERS_GET_KEYFOB_RESULT";

export const UNASSIGN_DRIVERS_SET_DEVICE = "UNASSIGN_DRIVERS_SET_DEVICE";

